<template>
  <div class="page final">
    <main>
      <div class="citybg"></div>
      <div class="ornamentline"></div>
      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">Neen, <br />ik wil geen kinderen.</h2>
          <p class="bodyslide--final">
            Zie jij een leven zonder kinderen helemaal zitten? Perfect! Vandaag
            kiezen veel singles of koppels ervoor om alleen of met zijn tweeën
            te blijven. onderzoek toont aan dat je helemaal geen kinderen hoeft
            te nemen om gelukkig te zijn.
          </p>
          <levensweg-button
            class="btn--final"
            label="Ontdek de feiten"
            color="blue down"
            link="#facts"
            type
          />
        </div>
        <div class="babylyingcontainer">
          <img
            src="./../assets/img/baby_lying_flipped.svg"
            alt=""
            class="babylying"
          />
        </div>
      </header>
      <section class="infosection" id="facts">
        <div class="leftblok">
          <header>
            <h3 class="sectiontitle">
              Wat als je later nog van idee verandert?
            </h3>
            <p class="sectionintro">
              Weet dan dat de vruchtbaarheid van de vrouw begint te dalen na 30
              jaar. Op 35 jarige leeftijd ben je als vrouw maar half zo
              vruchtbaar als toen je 25 was.
            </p>
          </header>
          <div class="articleblocks">
            <article>
              <h4 class="articletitle">Wat zijn de alternatieven?</h4>
              <p class="articlebody">
                Ook alternatieven zoals IVF en andere medisch begeleide
                voortplantingstechnieken worden sterk bepaald door leeftijd. Wil
                je nu geen kinderen, maar ben je nog niet 100% zeker over jouw
                toekomstige kinderwens? Bespreek dit dan even met je arts.
              </p>
            </article>
            <article>
              <h4 class="articletitle second">Wees voorbereid</h4>
              <p class="articlebody">
                Misschien vind je het wel een goede optie om jouw eicellen in te
                vriezen rond je 30ste? Misschien sta je wel open voor adoptie of
                pleegouderschap? Denk na over jouw back-up plan, dan ben je
                voorbereid op de toekomst.
              </p>
            </article>
          </div>
        </div>
        <div class="rightblok">
          <aside class="parentaside">
            <img src="./../assets/img/ivf_final.svg" alt="" class="ivf" />
          </aside>
          <div class="rightblock__line" />
        </div>
      </section>
      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton,
  },
};
</script>

<style>
.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}
.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}

.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}

.ivf {
  width: 342px;
  height: 324px;
}

.babylyingcontainer {
  margin-left: calc(-26.13% * 2);
  margin-top: -4rem;
  margin-bottom: 8rem;
  z-index: -2;
}

.babylying {
  width: auto;
  height: 291px;
  object-fit: cover;
}

.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}

.infosection {
  display: flex;
  flex-direction: column;
}

.articleblocks {
  display: flex;
  flex-direction: column;
}

.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  margin-right: 4.4rem;
}
.articlebody.noheading {
  margin-top: 3rem;
}
.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
    text-align: right;
  }
  .babylying {
    width: 80%;
    max-width: 449px;
    height: 80%;
    max-height: 374px;
  }
  .ivf {
    width: 308px;
    height: auto;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }
  .sectionintro {
    width: 75%;
  }
  .rightblok:after {
    position: relative;

    margin-top: -100%;
  }
}

@media only screen and (min-width: 992px) {
  .infosection {
    align-items: flex-start;
  }

  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }
  .sectionintro {
    width: 59.1rem;
  }

  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}

@media only screen and (min-width: 1200px) {
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
    width: 428px;
    max-width: 428px;
  }
  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
